import { render, staticRenderFns } from "./PickRec.vue?vue&type=template&id=765daabe&scoped=true"
import script from "./PickRec.vue?vue&type=script&lang=js"
export * from "./PickRec.vue?vue&type=script&lang=js"
import style0 from "./PickRec.vue?vue&type=style&index=0&id=765daabe&prod&lang=scss"
import style1 from "./PickRec.vue?vue&type=style&index=1&id=765daabe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765daabe",
  null
  
)

export default component.exports